export class BranchLoansReportModel {
  startDate: string;
  endDate: string;
  selectedBranch: any;
  printAllBranches: boolean;
  idNumber: string;
  userBranch: string;
}
